import { useCallback, useEffect, useMemo, useState } from "react";

import {
  ARBITRAGE_QUIZ_QUESTIONS,
  buildQuizQuestions,
} from "../utils/arbitrageJudoData";

export function useArbitrageQuiz(questionCount = 10) {
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [errors, setErrors] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const currentQuestion = questions[currentIndex];

  const progress = useMemo(() => {
    if (!questions.length) return 0;

    return Math.round(((currentIndex + 1) / questions.length) * 100);
  }, [currentIndex, questions.length]);

  const startQuiz = useCallback(() => {
    setQuestions(buildQuizQuestions(ARBITRAGE_QUIZ_QUESTIONS, questionCount));
    setCurrentIndex(0);
    setScore(0);
    setErrors([]);
    setShowResults(false);
  }, [questionCount]);

  useEffect(() => {
    startQuiz();
  }, [startQuiz]);

  const answerQuestion = useCallback(
    (answer) => {
      if (!currentQuestion) return;

      const isCorrect = answer === currentQuestion.correctAnswer;

      if (isCorrect) {
        setScore((prev) => prev + 1);
      } else {
        setErrors((prev) => [
          ...prev,
          {
            ...currentQuestion,
            selectedAnswer: answer,
          },
        ]);
      }

      if (currentIndex >= questions.length - 1) {
        setShowResults(true);
      } else {
        setCurrentIndex((prev) => prev + 1);
      }
    },
    [currentIndex, currentQuestion, questions.length],
  );

  return {
    questions,
    currentQuestion,
    currentIndex,
    score,
    errors,
    showResults,
    progress,
    startQuiz,
    answerQuestion,
  };
}